"use client";

import styles from "@/styles/modules/components/content.module.scss";
import FreeText from "./FreeText";
import Gallery from "./Gallery";
import { ContentComponent } from "@/types/modules";
import Link from "next/link";
import { useContext } from "react";
import { BookMenuContext } from "@/context/bookMenuContext";

interface ContentProps {
  content: ContentComponent;
}

export default function Content({ content }: ContentProps) {
  const { openBookMenu, setCurrentBookMenu, setEatAndDrinskRestaurantValue } =
    useContext(BookMenuContext);

  const handleButtonBedrooms = () => {
    setCurrentBookMenu(1);
    openBookMenu();
  };

  const handleButtonEvents = () => {
    setCurrentBookMenu(2);
    openBookMenu();
  };

  const handleButtonRestaurants = (slug?: string) => {
    setCurrentBookMenu(3);
    if (slug) {
      setEatAndDrinskRestaurantValue(slug);
    }
    openBookMenu();
  };

  return (
    <section
      className={`${styles.content} ${content.sameWidth ? styles.sameWidth : ""
        }`}
      style={{
        flexDirection: `${content.imageAlign[0] === "Right" ? "row" : "row-reverse"
          }`,
      }}
    >
      {content.title && <h2 data-aos="fadeIn" className={`h2 ${styles.titleMobile}`}>{content.title}</h2>}
      <div
        className={styles.text}
        style={{
          justifyContent: `${content.textAlign[0] === "Top" ? "flex-start" : "center"
            }`,
        }}
        data-aos="fadeIn"
       
      >
        {content.title && <h2 className="h2" data-aos="fadeIn">{content.title}</h2>}
        <FreeText content={content.content} />
        {content.button && content.button.title && content.button.url && (
          <Link
            className={styles.button}
            href={content.button.url}
            target={content.button.target}
          >
            {content.button.title}
          </Link>
        )}
        {content.buttonBedrooms && (
          <button className={styles.button} onClick={handleButtonBedrooms} data-aos="fade-in">
            {content.buttonBedrooms.text}
          </button>
        )}
        {content.buttonRestaurants && (
          <button
            className={styles.button}
            onClick={() =>
              handleButtonRestaurants(content.buttonRestaurants.restaurant)
            }
            data-aos="fade-in"
          >
            {content.buttonRestaurants.text}
          </button>
        )}
      </div>
      <div className={styles.gallery} >
        {content.gallery && <Gallery gallery={content.gallery} />}
      </div>
    </section>
  );
}
